var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "multipleLikeViewButton" }, [
    _vm._m(0),
    _vm._v(" "),
    _vm.$root.selectedShopCount > 0
      ? _c("div", { staticClass: "ui floating circular label" }, [
          _vm._v(_vm._s(_vm.$root.selectedShopCount)),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "a",
      { staticClass: "ui button", attrs: { href: "/checklist/" } },
      [
        _c("i", { staticClass: "icon bookmark outline" }),
        _vm._v("問合せリストを確認する"),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }